(() => {
  if (window.__ccHalloweenPromoCopyBound20261019) return;
  window.__ccHalloweenPromoCopyBound20261019 = true;

  const busy = new WeakSet();
  const resets = new WeakMap();

  const legacyCopy = (code) => {
    const focused = document.activeElement;
    const field = document.createElement('textarea');
    field.value = code;
    field.readOnly = true;
    field.setAttribute('aria-hidden', 'true');
    field.style.position = 'fixed';
    field.style.top = '0';
    field.style.left = '-9999px';
    document.body.append(field);
    let copied = false;
    try {
      field.select();
      field.setSelectionRange(0, code.length);
      copied = document.execCommand('copy');
    } catch (_) {
      copied = false;
    } finally {
      field.remove();
      if (focused instanceof HTMLElement && focused.isConnected) {
        focused.focus({ preventScroll: true });
      }
    }
    return copied;
  };

  const copy = async (code) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(code);
        return true;
      } catch (_) {}
    }
    return legacyCopy(code);
  };

  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const control = event.target.closest('button[data-cc-halloween-copy]');
    if (!control) return;
    const promo = control.closest('[data-cc-halloween-promo]');
    if (!promo) return;
    event.preventDefault();
    if (busy.has(promo)) return;

    const status = promo.querySelector('[data-cc-halloween-status]');
    const label = promo.querySelector('[data-cc-halloween-copy-label]');
    clearTimeout(resets.get(promo));
    if (status) status.textContent = '';
    if (label) label.textContent = promo.dataset.copyLabel;
    busy.add(promo);

    const copied = await copy('HW15');
    busy.delete(promo);
    if (!promo.isConnected) return;

    if (status) {
      status.textContent = copied ? promo.dataset.copySuccess : promo.dataset.copyError;
    }
    if (copied && label) label.textContent = promo.dataset.copiedLabel;
    if (copied) {
      resets.set(promo, window.setTimeout(() => {
        if (!promo.isConnected) return;
        if (label) label.textContent = promo.dataset.copyLabel;
        if (status) status.textContent = '';
      }, 2800));
    }
  });
})();
